export default __webpack_public_path__ + "static/media/warning--emu-crossing--g1.52d9cf04.png";